import NotasFiscaisLista from '@/pages/notasfiscais/NotasFiscaisLista.vue';
import NotasFiscaisForm from '@/pages/notasfiscais/NotasFiscaisForm.vue';

export default [
  {
    path: '/movimentacao/notasfiscais',
    name: 'NotasFiscaisLista',
    component: NotasFiscaisLista,
    meta: { permissao: 'notas_fiscais:acessar' },
  },
  {
    path: '/movimentacao/notasfiscais/adicionar',
    name: 'NotasFiscaisAdicionar',
    component: NotasFiscaisForm,
    meta: { permissao: 'notas_fiscais:adicionar' },
  },
  {
    path: '/movimentacao/notasfiscais/:id/editar',
    name: 'NotasFiscaisEditar',
    component: NotasFiscaisForm,
    meta: { permissao: 'notas_fiscais:editar' },
  }
];
